import React, { useEffect, useState, useRef } from "react";

export function ChartActionButtons(props) {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

    return <div className="mt-4 flex justify-center gap-0.5">
      <button
            className="w-auto px-2 py-2 rounded-lg border text-white shadow bg-primaryColor inline-flex items-center gap-2"
            onClick={props.onClick2}
            id="chart-watchlist-guide"
        >
         {/* 3 */}
          <img width={16} src="/plus-green.png"  /> Watchlist
        </button>
        <button
          onClick={props.onClick1}
          className="w-auto px-2 py-2 rounded-lg border text-white shadow bg-primaryColor inline-flex items-center gap-2"
          id="chart-save-chart-guide"
        >
        {/* 4 */}
          {isMobileView ? (
            <>
              {/* <img width={16} src="/plus-green.png" alt="plus" /> */}
              Save Chart
            </>
          ) : (
            <>Save Chart</>
          )}
        </button>
        <button
            className="w-auto px-2 py-2 rounded-lg border text-white shadow bg-primaryColor inline-flex items-center gap-2"
            onClick={props.onClick}
        >
          <img width={16} src="/plus-green.png"  /> Notifications
        </button>
    </div>;
}